import * as React from "react";
import { FaqWrapper, FaqTitle, FaqCategory, SearchFaqBox } from "./Faqs.style";
import { Accordion } from "./Accordion";
import { faqData } from "../../data/faqData";
import { SaveButton } from "../../styles/global";

export const FaqSummary = () => {
  return (
    <>
      <FaqWrapper>
        <FaqTitle>Frequently Asked Questions</FaqTitle>

        <FaqCategory>General</FaqCategory>

        {faqData.map((data) => (
          <Accordion key={data.id} title={data.title} content={data?.content} />
        ))}
        <div
          style={{
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            padding: "30px 0",
          }}
        >
          <SaveButton to="/faqs">See More</SaveButton>
        </div>
      </FaqWrapper>
    </>
  );
};
